const Backbone = require("backbone");
var ApiConfig = require("_lib/data/ApiConfig.js");

var ForgotUsername = Backbone.Model.extend({
  urlRoot: ApiConfig.getPrefix() + "/forgotlogin/username",
});

module.exports = ForgotUsername;
